import { render } from "./DashboardPartHistory.vue?vue&type=template&id=ce45ec50&scoped=true"
import script from "./DashboardPartHistory.vue?vue&type=script&lang=js"
export * from "./DashboardPartHistory.vue?vue&type=script&lang=js"

import "./DashboardPartHistory.vue?vue&type=style&index=0&id=ce45ec50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce45ec50"]])

export default __exports__